var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8H8V0H0V8ZM2 2H6V6H2V2ZM0 18H8V10H0V18ZM2 12H6V16H2V12ZM10 0V8H18V0H10ZM16 6H12V2H16V6ZM10.01 10H12.01V12H10.01V10ZM12.01 12H14.01V14H12.01V12ZM10.01 14H12.01V16H10.01V14ZM14.01 14H16.01V16H14.01V14ZM16.01 16H18.01V18H16.01V16ZM12.01 16H14.01V18H12.01V16ZM14.01 10H16.01V12H14.01V10ZM16.01 12H18.01V14H16.01V12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeIcon);
export default __webpack_public_path__ + "static/media/qr-code-icon.683275f5207ea8553eb68c4274ebf781.svg";
export { ForwardRef as ReactComponent };